export const haciendarole = {
  path: '/hacienda',
  redirect: 'noredirect',
  name: 'hacienda',
  single: false,
  meta: {
    title: 'HACIENDA MUNICIPAL',
    icon: 'audit',
    roles: ['super', 'admin', 'auditoria']
  }
}
export default haciendarole
